var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qc-success"},[_c('div',{staticClass:"success-wrap"},[_c('img',{staticClass:"success-img",attrs:{"src":_vm.successIcon,"alt":""}}),_c('div',{staticClass:"desc"},[_vm._v("提交成功")]),_c('van-button',{staticClass:"btn",attrs:{"plain":"","type":"primary"},on:{"click":_vm.btnClick}},[_vm._v("完成")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }